import React from 'react';

const Faculty = () => {
  return (
    <div>
      Faculty
      Faculty
    </div>
  );
}

export default Faculty;
